module.exports = __webpack_public_path__ + "static/media/messages.7016e47a.svg";